export default function CartIcon() {
  return (
    <>
      <path
        d='M2.75012 3.25L4.83012 3.61L5.79312 15.083C5.87012 16.02 6.65312 16.739 7.59312 16.736H18.5021C19.3991 16.738 20.1601 16.078 20.2871 15.19L21.2361 8.632C21.3421 7.899 20.8331 7.219 20.1011 7.113C20.0371 7.104 5.16412 7.099 5.16412 7.099'
        fill='none'
      />
      <path d='M14.1251 10.7969H16.8981' />
      <path
        d='M7.1535 20.2031C7.4545 20.2031 7.6975 20.4471 7.6975 20.7471C7.6975 21.0481 7.4545 21.2921 7.1535 21.2921C6.8525 21.2921 6.6095 21.0481 6.6095 20.7471C6.6095 20.4471 6.8525 20.2031 7.1535 20.2031Z'
        fill='#38383A'
      />
      <path
        d='M18.4347 20.2031C18.7357 20.2031 18.9797 20.4471 18.9797 20.7471C18.9797 21.0481 18.7357 21.2921 18.4347 21.2921C18.1337 21.2921 17.8907 21.0481 17.8907 20.7471C17.8907 20.4471 18.1337 20.2031 18.4347 20.2031Z'
        fill='#38383A'
      />
    </>
  );
}
